import { connect } from 'react-redux'
import {
  setEndDateChecker,
  getInvoices,
  updateQs,
  setStartDate,
  setEndDate,
  setSearchBy,
  setSearchKeyWords,
} from 'reduxpath/ducks/ZotapayInvoices/List'
import moment from 'moment'

import SearchBox from './units'

const mapStateToProps = state => ({
  debouncing: state.ZotapayInvoices.debouncing,
  qs: state.ZotapayInvoices.qs,
  isEndDateCheck: state.ZotapayInvoices.isEndDateCheck,
  startDate: state.ZotapayInvoices.startDate,
  endDate: state.ZotapayInvoices.endDate,
  searchBy: state.ZotapayInvoices.searchBy,
  searchKeyWords: state.ZotapayInvoices.searchKeyWords,
})

const mapDispatchToProps = dispatch => ({
  setSearchByParams(debouncing, qs, searchKeyWords, searchBy) {
    return (e) => {
      const searchByValue = e.target.value
      const newQs = {
        ...qs,
        skip: 0,
      }
      dispatch(setSearchBy(searchByValue))
      if (searchKeyWords) {
        // -- Remove last searchBy value from ducks qs -- //
        delete newQs.where[searchBy]
        newQs.where[searchByValue] = { like: `%${searchKeyWords}%` }
        debouncing(() => {
          dispatch(getInvoices(newQs))
          dispatch(updateQs(newQs))
        })
      }
    }
  },
  handleSearchKeyWord(debouncing, qs, searchBy) {
    return (e) => {
      let newQs = {}
      const keyWord = e.target.value
      dispatch(setSearchKeyWords(keyWord))
      newQs = {
        ...qs,
        skip: 0,
        where: {
          ...qs.where,
          [searchBy]: { like: `%${keyWord}%` },
        },
      }

      // -- For clear the query search params -- //
      if (keyWord === '') delete newQs.where[searchBy]

      debouncing(() => {
        dispatch(getInvoices(newQs))
        dispatch(updateQs(newQs))
      })
    }
  },
  setDate(debouncing, qs) {
    return (event, isStartDate) => {
      const date = isStartDate ? moment(event, 'YYYY-MM-DD') : moment(event, 'YYYY-MM-DD').add(1, 'days')
      const key = isStartDate ? '>=' : '<='
      const createdAt = {
        [key]: date,
      }
      let newQs

      // -- Condition for set query search by date -- //
      if (qs.where.createdAt) {
        newQs = {
          ...qs,
          skip: 0,
          where: {
            ...qs.where,
            createdAt: {
              ...qs.where.createdAt,
              [key]: date,
            },
          },
        }
      } else {
        newQs = {
          ...qs,
          skip: 0,
          where: {
            ...qs.where,
            createdAt,
          },
        }
      }
      dispatch(isStartDate ? setStartDate(event.format('YYYY-MM-DD')) : setEndDate(event.format('YYYY-MM-DD')))
      debouncing(() => {
        dispatch(getInvoices(newQs))
        dispatch(updateQs(newQs))
      })
    }
  },
  clearStartEndDate(debouncing, qs) {
    return () => {
      const newQs = {
        ...qs,
        skip: 0,
        where: {
          ...qs.where,
          createdAt: {},
        },
      }

      dispatch(setStartDate(null))
      dispatch(setEndDate(null))
      dispatch(setEndDateChecker(false))
      debouncing(() => {
        dispatch(getInvoices(newQs))
        dispatch(updateQs(newQs))
      })
    }
  },
})

const mergeProps = (stateProps, dispatchProps) => ({
  ...stateProps,
  ...dispatchProps,
  handleSearchKeyWord: dispatchProps.handleSearchKeyWord(
    stateProps.debouncing,
    stateProps.qs,
    stateProps.searchBy,
  ),
  setDate: dispatchProps.setDate(
    stateProps.debouncing,
    stateProps.qs,
  ),
  clearStartEndDate: dispatchProps.clearStartEndDate(
    stateProps.debouncing,
    stateProps.qs,
  ),
  setSearchByParams: dispatchProps.setSearchByParams(
    stateProps.debouncing,
    stateProps.qs,
    stateProps.searchKeyWords,
    stateProps.searchBy,
  ),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps,
)(SearchBox)
